import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import FinderStatus from './FinderStatus';
import Teaser from './Teaser';
import LocationSearch from './LocationSearch';
import Map from './Map';
import L from 'leaflet';
import { useCallback } from 'preact/compat';
import DeleteButton from './DeleteButton';
import LanguageSelect from './LanguageSelect';
import Pagination from './Pagination';
const allContacts = zankFinderData.contacts;
const allFunctions = zankFinderData.functions;
const allLanguages = zankFinderData.languages;
const allCountries = zankFinderData.countries;
const perPage = 20;
export default function ZankFinder() {
    const [bounds, setBounds] = useState(null);
    const [visibleBounds, setVisibleBounds] = useState(bounds);
    const [countryId, setCountryId] = useState(0);
    const [functionId, setFunctionId] = useState(0);
    const [languageIdOne, setLanguageIdOne] = useState(0);
    const [languageIdTwo, setLanguageIdTwo] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [locationTerm, setLocationTerm] = useState('');
    const [filteredContacts, setFilteredContacts] = useState([]);
    const [initialized, setInitialized] = useState(false);
    const resultsRef = useRef(null);
    const resetForm = useCallback(() => {
        setBounds(null);
        setLocationTerm('');
        setCountryId(0);
        setFunctionId(0);
        setLanguageIdOne(0);
        setLanguageIdTwo(0);
        setPage(1);
        setSearchTerm('');
    }, []);
    useUrlParams(bounds, setBounds, countryId, setCountryId, functionId, setFunctionId, languageIdOne, setLanguageIdOne, languageIdTwo, setLanguageIdTwo, searchTerm, setSearchTerm, locationTerm, setLocationTerm, page, setPage, setInitialized);
    const updateResults = () => {
        setFilteredContacts(getFilteredContacts(allContacts, countryId, bounds, functionId, searchTerm, languageIdOne, languageIdTwo));
        setVisibleBounds(bounds);
    };
    useEffect(() => {
        if (initialized) {
            updateResults();
        }
    }, [initialized]);
    useEffect(() => {
        //   updateResults();
    }, [bounds, countryId, functionId, searchTerm, languageIdOne, languageIdTwo]);
    const paginatedContacts = filteredContacts.length > perPage
        ? filteredContacts.slice((page - 1) * perPage, page * perPage)
        : filteredContacts;
    return (_jsxs(_Fragment, { children: [_jsx("a", Object.assign({ className: "visually-hidden-focusable", href: "#form" }, { children: zankFinderStrings.skipToForm }), void 0), _jsx(Map, { locations: filteredContacts, bounds: visibleBounds !== null && visibleBounds !== void 0 ? visibleBounds : undefined }, void 0), _jsxs("form", Object.assign({ id: "form", className: "zank-finder__form", onSubmit: (e) => e.preventDefault() }, { children: [_jsxs("div", Object.assign({ className: "zank-finder__form__function zank-finder__input-wrapper" }, { children: [_jsx("label", Object.assign({ id: "functions-label", className: "text-primary", htmlFor: "functions-select" }, { children: _jsx("b", { children: zankFinderStrings.functionsLabel }, void 0) }), void 0), _jsxs("div", Object.assign({ className: "input-delete-wrapper" }, { children: [_jsx("select", Object.assign({ id: "functions-select", value: functionId, onChange: (e) => setFunctionId(parseInt(e.currentTarget.value)) }, { children: allFunctions.map(({ label, id }) => (_jsx("option", Object.assign({ value: id }, { children: label }), id))) }), void 0), _jsx(DeleteButton, { label: zankFinderStrings.clearInputLabel, deleteFunction: () => setFunctionId(0), descriptionId: "functions-label", hidden: functionId === 0 }, void 0)] }), void 0)] }), void 0), _jsx("div", Object.assign({ className: "zank-finder__form__location zank-finder__input-wrapper" }, { children: _jsx(LocationSearch, { setBounds: setBounds, term: locationTerm, setTerm: setLocationTerm, setCountryId: setCountryId }, void 0) }), void 0), _jsxs("div", Object.assign({ className: "zank-finder__form__search zank-finder__input-wrapper" }, { children: [_jsx("label", Object.assign({ id: "search-label", htmlFor: "finder-search", className: "text-primary" }, { children: _jsx("b", { children: zankFinderStrings.searchLabel }, void 0) }), void 0), _jsxs("div", Object.assign({ className: "input-delete-wrapper" }, { children: [_jsx("input", { id: "finder-search", type: "text", value: searchTerm, onChange: (e) => setSearchTerm(e.currentTarget.value) }, void 0), _jsx(DeleteButton, { label: zankFinderStrings.clearInputLabel, deleteFunction: () => setSearchTerm(''), descriptionId: "search-label", hidden: searchTerm.length === 0 }, void 0)] }), void 0)] }), void 0), _jsx("div", Object.assign({ className: "zank-finder__form__language-one zank-finder__input-wrapper" }, { children: _jsx(LanguageSelect, { allLanguages: allLanguages, setLanguage: setLanguageIdOne, languageId: languageIdOne, label: zankFinderStrings.languageOneLabel, identifier: "1" }, void 0) }), void 0), _jsx("div", Object.assign({ className: "zank-finder__form__language-two zank-finder__input-wrapper" }, { children: _jsx(LanguageSelect, { allLanguages: allLanguages, setLanguage: setLanguageIdTwo, languageId: languageIdTwo, label: zankFinderStrings.languageTwoLabel, identifier: "2" }, void 0) }), void 0), _jsxs("div", Object.assign({ className: "zank-finder__form__submit-reset-wrapper" }, { children: [_jsx("button", Object.assign({ type: "submit", className: "zank-finder__form__submit zank-finder__button no-btn-style", onClick: () => {
                                    var _a;
                                    updateResults();
                                    setPage(1);
                                    // @ts-ignore
                                    if ((resultsRef === null || resultsRef === void 0 ? void 0 : resultsRef.current) instanceof HTMLElement) {
                                        // @ts-ignore
                                        (_a = resultsRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                                    }
                                } }, { children: zankFinderStrings.submitSearch }), void 0), (functionId ||
                                searchTerm ||
                                languageIdOne ||
                                languageIdTwo ||
                                locationTerm) && (_jsxs("button", Object.assign({ type: "reset", className: "zank-finder__form__reset", onClick: resetForm }, { children: [_jsx("svg", Object.assign({ "aria-hidden": "true", className: "icon icon-size-3" }, { children: _jsx("use", { href: "#close-circle" }, void 0) }), void 0), zankFinderStrings.resetForm] }), void 0))] }), void 0)] }), void 0), _jsxs("section", Object.assign({ className: "zank-finder__results" }, { children: [_jsx("h2", Object.assign({ className: "screen-reader-text" }, { children: zankFinderStrings.resultsHeading }), void 0), _jsx(FinderStatus, { count: filteredContacts.length, page: page, resultsRef: resultsRef }, void 0), paginatedContacts.map((contact) => (_jsx(Teaser, Object.assign({}, contact), contact.url))), _jsx(Pagination, { page: page, setPage: setPage, count: filteredContacts.length, perPage: perPage, resultsRef: resultsRef.current }, void 0)] }), void 0)] }, void 0));
}
function useUrlParams(bounds, setBounds, countryId, setCountryId, functionId, setFunctionId, languageIdOne, setLanguageIdOne, languageIdTwo, setLanguageIdTwo, searchTerm, setSearchTerm, locationTerm, setLocationTerm, page, setPage, setInitialized) {
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        const url = new URL(window.location.href);
        const bounds = url.searchParams.get('bounds');
        if (bounds) {
            const boundsArray = bounds.split('|');
            if (boundsArray.length === 4) {
                setBounds([
                    [parseFloat(boundsArray[0]), parseFloat(boundsArray[1])],
                    [parseFloat(boundsArray[2]), parseFloat(boundsArray[3])],
                ]);
            }
        }
        const page = parseInt((_a = url.searchParams.get('pag')) !== null && _a !== void 0 ? _a : '');
        if (page) {
            setPage(page);
        }
        const countryId = parseInt((_b = url.searchParams.get('country')) !== null && _b !== void 0 ? _b : '');
        if (countryId) {
            setCountryId(countryId);
        }
        const functionId = parseInt((_c = url.searchParams.get('function')) !== null && _c !== void 0 ? _c : '');
        if (functionId) {
            setFunctionId(functionId);
        }
        const languageOne = parseInt((_d = url.searchParams.get('langOne')) !== null && _d !== void 0 ? _d : '');
        if (languageOne) {
            setLanguageIdOne(languageOne);
        }
        const languageTwo = parseInt((_e = url.searchParams.get('langTwo')) !== null && _e !== void 0 ? _e : '');
        if (languageTwo) {
            setLanguageIdTwo(languageTwo);
        }
        const searchTerm = url.searchParams.get('search');
        if (searchTerm) {
            setSearchTerm(searchTerm);
        }
        const locationTerm = url.searchParams.get('location');
        if (locationTerm) {
            setLocationTerm(locationTerm);
        }
        setInitialized(true);
    }, []);
    useEffect(() => {
        const url = new URL(window.location.href);
        for (const key of [
            'bounds',
            'country',
            'function',
            'langOne',
            'langTwo',
            'search',
            'location',
            'pag',
        ]) {
            url.searchParams.delete(key);
        }
        if (page > 1) {
            url.searchParams.set('pag', page.toString());
        }
        if (Array.isArray(bounds)) {
            const boundsArray = [...bounds[0], ...bounds[1]];
            url.searchParams.set('bounds', boundsArray.join('|'));
        }
        if (countryId) {
            url.searchParams.set('country', countryId.toString());
        }
        if (functionId) {
            url.searchParams.set('function', functionId.toString());
        }
        if (languageIdOne) {
            url.searchParams.set('langOne', languageIdOne.toString());
        }
        if (languageIdTwo) {
            url.searchParams.set('langTwo', languageIdTwo.toString());
        }
        if (searchTerm) {
            url.searchParams.set('search', searchTerm);
        }
        if (locationTerm) {
            url.searchParams.set('location', locationTerm);
        }
        window.history.replaceState({}, '', url);
    }, [
        bounds,
        countryId,
        functionId,
        languageIdOne,
        languageIdTwo,
        searchTerm,
        locationTerm,
        page,
    ]);
}
function getFilteredContacts(allContacts, countryId, bounds, functionId, searchTerm, languageIdOne, languageIdTwo) {
    const noCountryFilter = countryId === 0;
    const noFunctionFilter = functionId === 0;
    const languageIds = [];
    if (languageIdOne) {
        languageIds.push(languageIdOne);
    }
    if (languageIdTwo) {
        languageIds.push(languageIdTwo);
    }
    const noLanguagesFilter = languageIds.length === 0;
    const searchRegEx = searchTerm.length > 1 ? new RegExp(searchTerm, 'i') : null;
    const boundsObject = Array.isArray(bounds) && (bounds === null || bounds === void 0 ? void 0 : bounds.length) === 2
        ? new L.LatLngBounds(bounds)
        : false;
    return allContacts
        .filter((contact) => !noCountryFilter || // Ignore bounds if countryId is selected and thus used for location filtering
        !boundsObject ||
        boundsObject.contains(contact.geolocation))
        .filter(({ countries }) => noCountryFilter || countries.includes(countryId))
        .filter(({ functions }) => noFunctionFilter || functions.includes(functionId))
        .filter(({ languages }) => noLanguagesFilter ||
        languages.some((language) => languageIds.includes(language)))
        .filter(({ title, description, city, functions: functionIds, languages: languageIds, countries: countryIds, }) => !searchRegEx ||
        searchRegEx.test(title) ||
        searchRegEx.test(description) ||
        searchRegEx.test(city) ||
        functionIds.some((id) => {
            var _a;
            const label = (_a = allFunctions.find(({ id: termId }) => termId === id)) === null || _a === void 0 ? void 0 : _a.label;
            return label && searchRegEx.test(label);
        }) ||
        languageIds.some((id) => {
            var _a;
            const label = (_a = allLanguages.find(({ id: termId }) => termId === id)) === null || _a === void 0 ? void 0 : _a.label;
            return label && searchRegEx.test(label);
        }) ||
        countryIds.some((id) => {
            const country = allCountries.find(({ termId }) => termId === id);
            return (country &&
                (searchRegEx.test(country.place_name) ||
                    country.altNames.some((name) => searchRegEx.test(name))));
        }));
}
